import React from 'react';
import SectionHeader from '../components/sections/partials/SectionHeader';
import { useLanguage } from '../context/LanguageContext';

export default function TermsOfService() {
  const { language, text } = useLanguage();
  const [content, setContent] = React.useState('');
  const [failed, setFailed] = React.useState(false);
  React.useEffect(() => {
    let cancelled = false;
    setContent(''); setFailed(false);
    fetch(`/terms/${language}.md`).then(response => {
      if (!response.ok) throw new Error('Terms unavailable');
      return response.text();
    }).then(value => { if (!cancelled) setContent(value); })
      .catch(() => { if (!cancelled) setFailed(true); });
    return () => { cancelled = true; };
  }, [language]);
  return <section className="section"><div className="container"><div className="section-inner">
    <SectionHeader data={{ title: text('利用規約', 'Terms of Service') }} className="center-content" />
    <div className="terms-content legal-content" style={{ textAlign: 'left', lineHeight: 1.8 }}>
      {failed && <p role="alert">{text('利用規約を読み込めませんでした。再読み込みしてください。', 'Unable to load the terms. Please reload the page.')}</p>}
      {!content && !failed && <p>{text('読み込み中…', 'Loading…')}</p>}
      {content.split(/\r?\n\s*\r?\n/).filter(Boolean).slice(1).map((block, index) => {
        if (block.startsWith('### ')) return <h2 key={index} style={{ fontSize: 24, marginTop: 32 }}>{block.slice(4)}</h2>;
        if (/^-{3,}$/.test(block.trim())) return <hr key={index} />;
        return <p key={index} style={{ whiteSpace: 'pre-wrap' }}>{block.replace(/\*\*/g, '')}</p>;
      })}
    </div>
  </div></div></section>;
}
